const CHART_INTERVALS = {
  '1m': ['minute', 1, 60_000],
  '5m': ['minute', 5, 300_000],
  '15m': ['minute', 15, 900_000],
  '30m': ['minute', 30, 1_800_000],
  '1h': ['hour', 1, 3_600_000],
  '4h': ['hour', 4, 14_400_000],
  '1d': ['day', 1, 86_400_000],
};

export function getChartInterval(timeFrame) {
  const [timeUnit, count] = CHART_INTERVALS[timeFrame] || CHART_INTERVALS['1m'];
  return { timeUnit, count };
}

export function getChartIntervalMs(timeFrame) {
  return (CHART_INTERVALS[timeFrame] || CHART_INTERVALS['1m'])[2];
}
